'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useWindowResizeHandler } from '../../../hooks/useWindowResizeHandler';
import { useFrameBorder } from './FrameBorderContext';
interface SvgFallbackProps {
  top: number;
  right: number;
  bottom: number;
  left: number;
  borderRadius: number;
  bottomOverflow: number;
}
export function SvgFallback(props) {
  const $ = _c(31);
  const {
    top,
    right,
    bottom,
    left,
    borderRadius,
    bottomOverflow
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: 0,
      height: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [size, setSize] = useState(t0);
  const showBorder = useFrameBorder();
  let t1;
  if ($[1] !== bottomOverflow) {
    t1 = () => setSize({
      width: document.documentElement.clientWidth,
      height: window.innerHeight + bottomOverflow
    });
    $[1] = bottomOverflow;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useWindowResizeHandler(t1);
  const innerWidth = Math.max(0, size.width - left - right);
  const innerHeight = Math.max(0, size.height - top - bottom - bottomOverflow);
  let t2;
  if ($[3] !== size.height || $[4] !== size.width) {
    t2 = <rect fill="white" width={size.width} height={size.height} />;
    $[3] = size.height;
    $[4] = size.width;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== borderRadius || $[7] !== innerHeight || $[8] !== innerWidth || $[9] !== left || $[10] !== top) {
    t3 = <rect x={left} y={top} width={innerWidth} height={innerHeight} rx={borderRadius} ry={borderRadius} fill="black" />;
    $[6] = borderRadius;
    $[7] = innerHeight;
    $[8] = innerWidth;
    $[9] = left;
    $[10] = top;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <defs><mask id="svgMask">{t2}{t3}</mask></defs>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== size.height || $[16] !== size.width) {
    t5 = <rect mask="url(#svgMask)" className="fill-background" style={{
      width: size.width,
      height: size.height
    }} />;
    $[15] = size.height;
    $[16] = size.width;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== borderRadius || $[19] !== innerHeight || $[20] !== innerWidth || $[21] !== left || $[22] !== showBorder || $[23] !== top) {
    t6 = showBorder && <rect x={left} y={top} width={innerWidth} height={innerHeight} rx={borderRadius} ry={borderRadius} fill="none" className="stroke-black/20 dark:stroke-[#fafafa]/15" strokeWidth={0.5} />;
    $[18] = borderRadius;
    $[19] = innerHeight;
    $[20] = innerWidth;
    $[21] = left;
    $[22] = showBorder;
    $[23] = top;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== size.height || $[26] !== size.width || $[27] !== t4 || $[28] !== t5 || $[29] !== t6) {
    t7 = <svg xmlns="http://www.w3.org/2000/svg" width={size.width} height={size.height} className="pointer-events-none fixed top-0 left-0 z-30">{t4}{t5}{t6}</svg>;
    $[25] = size.height;
    $[26] = size.width;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
}